import React, { useState, useRef, useEffect } from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import makeRequest from 'utils/makeRequest';
import Cookie from 'utils/cookies';
import { TOI_LIVE_DOMAIN, UNIFIED_FEED_DOMAIN_SERVICE } from 'constants';
import AdCaller from 'helpers/ads/adCaller';
import s from './BiharBoardResult.scss';

const BiharBoardResult = props => {
  const { data, seoData, fromIframe } = props;

  // const isTextValid = textInput => {
  //   if (!textInput) {
  //     return false;
  //   }
  //   return true;
  // };
  const formRef = useRef(null);

  const scrollToTop = () => {
    if (formRef.current) {
      try {
        const offset = 200;
        const targetPosition = formRef.current.getBoundingClientRect().top;
        const currentPosition = window.scrollY;
        const scrollToPosition = targetPosition + currentPosition - offset;

        window.scrollTo({
          top: scrollToPosition,
          behavior: 'smooth',
        });
      } catch (e) {
        console.log('error while scrolling');
      }
    }
  };

  const isNumberValid = numberInput => {
    const regex = /^[0-9]+$/;
    return regex.test(numberInput);
  };

  const isEmailValid = email => {
    let validemail = true;
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
    );
    if (!pattern.test(email)) {
      validemail = false;
    }
    return validemail;
  };

  const isValidMobileNumber = number => {
    const regex = /^\d{10}$/; // This regex matches exactly 10 digits
    return regex.test(number);
  };

  const isValidFullName = name => {
    if (!(name && typeof name === 'string')) {
      return false;
    }
    const maxLength = 70;
    const regex = /^[A-Za-z\s\-']+$/; // Allows letters, spaces, hyphens, and apostrophes

    return name.length > 0 && name.length <= maxLength && regex.test(name);
  };

  const [userNameInput, setUserNameInput] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [isUserNameValid, setIsUserNameValid] = useState(false);

  const [userEmailInput, setUserEmailInput] = useState('');
  const [isUserEmailValid, setIsUserEmailValid] = useState(false);

  const [userMobileInput, setUserMobileInput] = useState('');
  const [isUserMobileValid, setIsUserMobileValid] = useState(false);

  const [rollcodeInput, setRollcodeInput] = useState('');
  const [isRollcodeValid, setIsRollcodeValid] = useState(false);

  const [rollnoInput, setRollnoInput] = useState('');
  const [isRollnoValid, setIsRollnoValid] = useState(false);

  const [isResultNotFound, setIsResultNotFound] = useState(false);
  const [showResultAwaitedMessage, setShowResultAwaitedMessage] = useState(
    false,
  );

  // eslint-disable-next-line no-unused-vars
  const [showResultPage, setShowResultPage] = useState(false);
  const [showErrorMessages, setShowErrorMessages] = useState(false);
  const [resultData, setResultData] = useState(undefined);

  let resultInfoText = '12th';
  if (data && data.defaultText) {
    resultInfoText = data.defaultText;
  } else if (data && data.className && data.className === '10') {
    resultInfoText = '10th';
  }

  const fireClickGa = category => {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: `result_form_${resultInfoText}_bihar_board`,
      label: data && data.title,
      category,
    });
  };

  const resetForm = () => {
    setUserNameInput('');
    setIsUserNameValid(false);
    setUserEmailInput('');
    setIsUserEmailValid(false);
    setUserMobileInput('');
    setIsUserMobileValid(false);
    setRollnoInput('');
    setIsRollnoValid(false);
    setRollcodeInput('');
    setIsRollcodeValid(false);
    setShowErrorMessages(false);
    setShowResultPage(false);
    setIsResultNotFound(false);
    setShowResultAwaitedMessage(false);
    setResultData(undefined);
    fireClickGa('check_other_result');
  };

  useEffect(() => {
    if (data && !(data.hideForm === '1')) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: `result_form_${resultInfoText}_bihar_board`,
        label: data && data.title,
      });
    }
  }, []);

  const fireSubmitGa = () => {
    if (fromIframe) {
      analyticsWrapper('ga4', {
        event: 'form_submit',
        type: `result_form_${resultInfoText}_bihar_board`,
        label: data && data.title,
        category: 'nbt_iframe',
      });
    } else if (resultInfoText && resultInfoText === '12th') {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'bihar result 2025',
        label: `${rollcodeInput}-${rollnoInput}`,
        category: data?.ga4Type || data?.ga_type || '12th Class',
      });
    } else {
      analyticsWrapper('ga4', {
        event: 'form_submit',
        type: `result_form_${resultInfoText}_bihar_board`,
        label: data && data.title,
      });
    }
  };

  const onSubmit = () => {
    if (
      !(
        isUserEmailValid &&
        // isUserNameValid &&
        isUserMobileValid &&
        isRollcodeValid &&
        isRollnoValid
      )
    ) {
      setShowErrorMessages(true);
      return;
    }
    const uid = Cookie.get('_col_uuid');
    const postData = {
      name: userNameInput,
      class: resultInfoText,
      email: userEmailInput,
      mobile: userMobileInput,
      rollnumber: rollnoInput,
      rollcode: rollcodeInput,
      columbia_id: uid || '',
    };
    makeRequest.post(
      `https://psn.timesofindia.com/events-manager/result/search-data/save${
        resultInfoText === '10th' ? '?rt=bb_10' : ''
      }`,
      postData,
    );
    // `https://psn.timesofindia.com/events-manager/result/get?rollnumber=${rollnoInput}&rollcode=${rollcodeInput}${
    //           resultInfoText === '10th' ? '&rt=bb_10' : ''
    //         }`,
    if (
      data &&
      data.resultDeclarationState &&
      data.resultDeclarationState === 'announced'
    ) {
      makeRequest
        .get(
          `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/utility/result/detail/${
            resultInfoText === '10th' ? '108666645' : '108636546'
          }?rollnumber=${rollnoInput}&rollcode=${rollcodeInput}`,
          {},
          'skipfeedengine',
        )
        .catch(() => {
          setIsResultNotFound(true);
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: `result_form_${resultInfoText}_bihar_board`,
            label: 'Result not found! Please check your roll code and roll no.',
          });
        })
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data &&
            response.data.division
          ) {
            setResultData({ ...response.data });
            setShowResultPage(true);
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: `result_form_${resultInfoText}_bihar_board`,
              label: data && data.title,
              category: 'result_shown',
            });
            scrollToTop();
          } else {
            setIsResultNotFound(true);
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: `result_form_${resultInfoText}_bihar_board`,
              label:
                'Result not found! Please check your roll code and roll no.',
            });
          }
        });
    }
    if (
      data &&
      data.resultDeclarationState &&
      data.resultDeclarationState === 'result_awaited'
    ) {
      setShowResultAwaitedMessage(true);
    }

    fireSubmitGa();
  };

  const handleInputTextChange = event => {
    if (event && event.target && event.target.id) {
      const inputVal = event.target.value;
      if (event.target.id === 'bihar-board-input-name') {
        const valid = isValidFullName(inputVal);
        setUserNameInput(inputVal);
        setIsUserNameValid(valid);
      } else if (event.target.id === 'bihar-board-input-rollno') {
        const valid = isNumberValid(inputVal);
        setRollnoInput(inputVal);
        setIsRollnoValid(valid);
      } else if (event.target.id === 'bihar-board-input-rollcode') {
        const valid = isNumberValid(inputVal);
        setRollcodeInput(inputVal);
        setIsRollcodeValid(valid);
      } else if (event.target.id === 'bihar-board-input-email') {
        const valid = isEmailValid(inputVal);
        setUserEmailInput(inputVal);
        setIsUserEmailValid(valid);
      } else if (event.target.id === 'bihar-board-input-mobile') {
        const valid = isValidMobileNumber(inputVal);
        setUserMobileInput(inputVal);
        setIsUserMobileValid(valid);
      }
    }
  };

  const downloadPdf = () => {
    if (typeof window === 'object' && window.jspdf && window.html2canvas) {
      const { jsPDF } = window.jspdf;
      const originalElement = document.getElementById('result-image-download');
      if (originalElement && jsPDF) {
        window
          .html2canvas(originalElement)
          .then(canvas => {
            const imgData = canvas.toDataURL('image/jpeg', 0.75);
            // eslint-disable-next-line new-cap
            const pdf = new jsPDF();

            pdf.addImage(imgData, 'PNG', 0, 0, 210, 297); // A4 size in mm
            pdf.setTextColor('#0000FF');
            pdf.setFontSize(11);

            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = canvasHeight * pdfWidth / canvasWidth;

            pdf.textWithLink('Click here', 78, pdfHeight - 20, {
              url:
                seoData && seoData.canonical
                  ? seoData.canonical
                  : `${TOI_LIVE_DOMAIN}/${props.location}`,
            });
            pdf.setTextColor('#595959');
            pdf.text('to check your result', 97, pdfHeight - 20);
            pdf.save(`BiharBoard_Results_2025.pdf`);
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
    fireClickGa('download_result');
  };

  const shareResult = () => {
    if (navigator && navigator.share) {
      const titletoBeShared =
        data && data.title ? data.title : 'Bihar Board Result 2025';
      navigator
        .share({
          // title: titletoBeShared,
          text: `${titletoBeShared}\n\n#BiharBoardResults #${resultInfoText}Results #TOI\n\nI checked my result on TOI\nRoll Number - ${rollnoInput}\nRoll Code - ${rollcodeInput}\nResult/Division - ${
            resultData && resultData.division ? resultData.division : ''
          }\n\nCheck out detailed results on Times of India website!\n🔗${
            seoData && seoData.canonical
              ? seoData.canonical
              : `${TOI_LIVE_DOMAIN}/${props.location}`
          }\n\nDownload the TOI app for more updates and educational content!\n📱📚 https://timesofindia.onelink.me/mjFd/4haofaqr`,
          // url: seoData
          //   ? seoData.canonical
          //   : `${TOI_LIVE_DOMAIN}/${props.location}`,
        })
        .catch(error => console.log('Error sharing:', error));
    } else {
      console.log('Web Share API is not supported in your browser.');
    }
    fireClickGa('share_result');
  };

  const isResultPageVisible = showResultPage && resultData;

  const isMatricform = resultInfoText && resultInfoText === '10th';

  const getFormHTML = () => (
    <>
      <h1 className={s.main_heading}>
        {data && data.title ? data.title : 'Bihar Board Result 2025'}
      </h1>
      {isResultPageVisible && (
        <div className={`${s.result_show}`}>
          <div className={s.result_rank}>
            <div className={s.head}>Result/Division:</div>
            <div className={s.numbers}>{resultData?.division || ''}</div>
          </div>
          <div className={s.result_details}>
            <div>
              <div className={s.head}>Roll Number:</div>
              <div className={s.numbers}>{resultData?.roll_number || ''}</div>
            </div>
            <div>
              <div className={s.head}>Roll Code:</div>
              <div className={s.numbers}>{resultData?.roll_code || ''}</div>
            </div>
            {/* <div>
              <div className={s.head}>District:</div>
              <div className={s.numbers}>{resultData?.district || ''}</div>
            </div> */}
          </div>
        </div>
      )}
      {!isResultPageVisible && (
        <>
          <p className={s.info_text}>
            Kindly provide the information below to access your Bihar Board{' '}
            {isMatricform ? 'Matric' : 'Intermediate'} ({resultInfoText})
            result.
          </p>
          <div className={`${s.form_container} ${s.biharBoardPage}`}>
            {/* <div
              className={`${s.input_group} ${
                !isUserNameValid && showErrorMessages ? s.input_error : ''
              }`}
            >
              <div className={s.input_name}>
                Full Name<sup>*</sup>
              </div>
              <input
                type="text"
                id="bihar-board-input-name"
                placeholder="Enter your Full Name"
                onChange={handleInputTextChange}
                value={userNameInput}
              />
              {!isUserNameValid &&
                showErrorMessages && (
                  <div className={s.error}>Please enter a valid Name</div>
                )}
            </div> */}
            <div
              className={`${s.input_group} ${s.rollCode} ${
                !isRollcodeValid && showErrorMessages ? s.input_error : ''
              }`}
            >
              <div className={s.input_name}>
                Roll Code<sup>*</sup>
              </div>
              <input
                type="number"
                placeholder="101"
                id="bihar-board-input-rollcode"
                onChange={handleInputTextChange}
                value={rollcodeInput}
              />
              {!isRollcodeValid &&
                showErrorMessages && (
                  <div className={s.error}>Enter a valid Roll code</div>
                )}
            </div>

            <div
              className={`${s.input_group} ${s.rollNumber} ${
                !isRollnoValid && showErrorMessages ? s.input_error : ''
              }`}
            >
              <div className={s.input_name}>
                Roll Number<sup>*</sup>
              </div>
              <input
                type="number"
                placeholder="12345678"
                id="bihar-board-input-rollno"
                onChange={handleInputTextChange}
                value={rollnoInput}
              />
              {!isRollnoValid &&
                showErrorMessages && (
                  <div className={s.error}>Enter a valid Roll Number</div>
                )}
            </div>
            <div
              className={`${s.input_group} ${s.mobileNumber} ${
                !isUserMobileValid && showErrorMessages ? s.input_error : ''
              }`}
            >
              <div className={s.input_name}>
                Mobile Number<sup>*</sup>
              </div>
              <input
                type="number"
                placeholder="Enter your Mobile No."
                id="bihar-board-input-mobile"
                onChange={handleInputTextChange}
                value={userMobileInput}
              />
              {!isUserMobileValid &&
                showErrorMessages && (
                  <div className={s.error}>Enter a valid Mobile no.</div>
                )}
            </div>
            <div
              className={`${s.input_group} ${s.emailid} ${
                !isUserEmailValid && showErrorMessages ? s.input_error : ''
              }`}
            >
              <div className={s.input_name}>
                Email ID<sup>*</sup>
              </div>
              <input
                type="text"
                placeholder="abc@gmail.com"
                id="bihar-board-input-email"
                onChange={handleInputTextChange}
                value={userEmailInput}
              />
              {!isUserEmailValid &&
                showErrorMessages && (
                  <div className={s.error}>Enter a valid E-mail</div>
                )}
            </div>
          </div>
          <div className={s.btn_group}>
            <button className={s.submit_btn} type="submit" onClick={onSubmit}>
              Submit
            </button>
            {isResultNotFound && (
              <div className={s.error}>
                <span>Result not found!</span> Please check your roll code and
                roll no.
              </div>
            )}
            {showResultAwaitedMessage && (
              <div className={s.error}>
                <span>Result Awaited</span>
              </div>
            )}
          </div>
          <div className={`${s.info_text} ${s.f_12px}`}>
            By submitting, you agree to the Terms &amp; Conditions and authorise
            Times of India to provide you the Bihar Board{' '}
            {isMatricform ? 'Matric' : 'Intermediate'} ({resultInfoText})
            result.
          </div>
        </>
      )}
      {isResultPageVisible && (
        <div
          id="result-image-download"
          style={{
            position: 'absolute',
            left: '-9999px',
          }}
          className={s.biharBoardPage}
        >
          <div className={s.result_print}>
            <div className={s.toi_logo}>TOI</div>
            <h1 className={s.main_heading}>
              {data && data.pdfTitle
                ? data.pdfTitle
                : `BSEB Bihar Board ${
                    isMatricform ? '10th Matric' : '12th Intermediate'
                  } Result 2025`}
            </h1>
            <div className={s.result_show}>
              <div className={s.result_rank}>
                <div className={s.head}>Result/Division:</div>
                <div className={s.numbers}>{resultData?.division || ''}</div>
              </div>
              <div className={s.result_details}>
                <div>
                  <div className={s.head}>Roll Number:</div>
                  <div className={s.numbers}>
                    {resultData?.roll_number || ''}
                  </div>
                </div>
                <div>
                  <div className={s.head}>Roll Code:</div>
                  <div className={s.numbers}>{resultData?.roll_code || ''}</div>
                </div>
                {/* <div>
                  <div className={s.head}>District:</div>
                  <div className={s.numbers}>{resultData?.district || ''}</div>
                </div> */}
              </div>
            </div>
            <div className={s.logo_toi_btm}>
              <div className={s.times_logo}>The Times of india</div>
            </div>
          </div>
        </div>
      )}
    </>
  );

  const getTextHtml = () => (
    <>
      <h1 className={s.main_heading}>
        {data && data.title
          ? data.title
          : 'Bihar Board Result 2025: : Step-by-step guideline to check'}
      </h1>
      <ul className={s.guideline}>
        {isMatricform ? (
          <>
            <li>
              <span>Step 1:</span> Go to the official website at
              <a
                href="http://bsebmatric.org/"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                bsebmatric.org
              </a>{' '}
              or
              <a
                href="http://results.biharboardonline.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                results.biharboardonline.com
              </a>
            </li>
            <li>
              <span>Step 2:</span> On the homepage, click on the link given for
              Secondary Schools.
            </li>
            <li>
              <span>Step 3:</span> A new webpage will open, now tap on the link
              given for BSEB Matric Result 2025.
            </li>
            <li>
              <span>Step 4:</span> Another window will appear, enter your login
              details such as Roll Number and Roll Code.
            </li>
            <li>
              <span>Step 5:</span> Your Bihar Board Class 10 Scorecard 2025 will
              be displayed on the screen.
            </li>
            <li>
              <span>Step 6:</span> Download the result page and get its hard
              copy for further use.
            </li>
          </>
        ) : (
          <>
            <li>
              <span>Step 1:</span> Go to the official website at
              <a
                href="http://biharboardonline.bihar.gov.in/"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                http://biharboardonline.bihar.gov.in/
              </a>{' '}
              or
              <a
                href="http://secondary.biharboardonline.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                http://secondary.biharboardonline.com
              </a>{' '}
              or
              <a
                href="http://results.biharboardonline.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                http://results.biharboardonline.com/
              </a>
            </li>
            <li>
              <span>Step 2:</span> On the homepage, click on the link displayed
              for Inter exam results.
            </li>
            <li>
              <span>Step 3:</span> A new window will open, enter your roll
              number and roll code.
            </li>
            <li>
              <span>Step 4:</span> Your BSEB Class 12 Result 2025 will be
              displayed on the screen.
            </li>
            <li>
              <span>Step 5:</span> Download the Bihar Board result 2025 and get
              its printout for further reference.
            </li>
          </>
        )}
        <div className={s.btn_group}>
          <a
            href={data && data.ctaLink ? data.ctaLink : '/'}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={s.submit_btn}
          >
            CHECK YOUR RESULT <span />
          </a>
        </div>
      </ul>
    </>
  );

  return (
    <div className={`${s.resultpage_wrap} resultpage_wrap`} ref={formRef}>
      <div className={s.result_page}>
        <div className={s.lhs}>
          <div className={`${s.result_lhs} ${s.result_show_bihar}`}>
            {data && data.hideForm === '1' ? getTextHtml() : getFormHTML()}
            {/* <div className={s.action_btns}> */}
            {isResultPageVisible && (
              <div className={s.action_btns}>
                <div className={s.check_link} onClick={resetForm}>
                  Check Another Result
                </div>
                <div className={s.btn_grp}>
                  <button
                    className={`${s.submit_btn} ${s.download}`}
                    onClick={downloadPdf}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M7 10.5769L3.46152 7.03845L4.16923 6.31923L6.5 8.65V0H7.5V8.65L9.83078 6.31923L10.5385 7.03845L7 10.5769ZM1.61537 14C1.15512 14 0.770833 13.8458 0.4625 13.5375C0.154167 13.2292 0 12.8449 0 12.3846V9.96155H1V12.3846C1 12.5385 1.0641 12.6795 1.1923 12.8077C1.32052 12.9359 1.46154 13 1.61537 13H12.3846C12.5385 13 12.6795 12.9359 12.8077 12.8077C12.9359 12.6795 13 12.5385 13 12.3846V9.96155H14V12.3846C14 12.8449 13.8458 13.2292 13.5375 13.5375C13.2292 13.8458 12.8449 14 12.3846 14H1.61537Z"
                        fill="#E21B22"
                      />
                    </svg>{' '}
                    DOWNLOAD
                  </button>
                  {props.isWapView && (
                    <button
                      className={`${s.submit_btn} ${s.share}`}
                      onClick={shareResult}
                    >
                      <i />
                      SHARE
                    </button>
                  )}
                </div>
              </div>
            )}
            {/* </div> */}
          </div>
        </div>
        <div className={`${s.leftColSpacing}`}>
          <div className={s.rhsstickybox}>
            {!props.isPrime &&
              data &&
              data.adCode && (
                <div className="paisa-wrapper mrec_placeHolder">
                  <AdCaller
                    data={{
                      name: 'mrec',
                      adCode: data.adCode,
                      size: [300, 250],
                      divId: '637c6e6bcdd25404cdac0746-mrec',
                    }}
                  />
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

BiharBoardResult.propTypes = {};

BiharBoardResult.defaultProps = {};

export default BiharBoardResult;
